import axios from 'axios'

const BASE_URL = process.env.NODE_ENV === 'production' ? '' : 'http://localhost:3000'

export const loadInitialState = async function({commit, state}){
  try {
    state.eventsLoaded = false
    const response = await axios.get(BASE_URL + '/rpc/loadInit')
    commit('setCurrentTeam', process.env.VUE_APP_TEAM)
    // eslint-disable-next-line
    // console.log('CurrentTeam', process.env.VUE_APP_STORE_TEAM)
    commit('setInitialState', response.data)
    return response.data
  } catch(err) {
    return {error: err}
  }
}

export const registerForEvent = async function({commit, state}, payload) {
  let reg = {
    ...state.currentRegistration
  }
  reg.status = null
  reg['event-id'] = null
  try {
    const response = await (axios.post(BASE_URL + '/rpc/createReg/'+payload, reg))
    commit('setCurrentRegistration', response.data)
    commit('addRegistration', response.data)
    return response.data
  } catch(err) {
    return {error: err}
  }
}

export const loadRegistration = async function(_, payload) {
  const response = await axios.get(BASE_URL + '/rpc/loadRegistration/' + payload)
  return response.data
}

export const payRegistration = async function(_, payload) {
  // create charge
  const charge = {
    'creditcard': payload.creditcard,
    'creditcard-expiration': payload['creditcard-expiration'],
    'creditcard-cvv2': payload['creditcard-cvv2'],
    'billing-fname': payload['billing-fname'],
    'billing-lname': payload['billing-lname'],
    'billing-address': payload['billing-address'],
    'billing-city': payload['billing-city'],
    'billing-state': payload['billing-state'],
    'billing-zip': payload['billing-zip'],
    'billing-country': payload['billing-country']
  }
  const regId = payload.regId
  try {
    const response = await (axios.post(BASE_URL + '/rpc/postTransaction/'+regId, charge))
    return response.data
  } catch(err) {
    return {error: true, err: err, error_detail: 'There was an error on our server. Please contact support for help.'}
  }
}

export const paySingleRegistration = async function(_, payload) {
  // create charge
  const charge = {
    'creditcard': payload.creditcard,
    'creditcard-expiration': payload['creditcard-expiration'],
    'creditcard-cvv2': payload['creditcard-cvv2'],
    'billing-fname': payload['billing-fname'],
    'billing-lname': payload['billing-lname'],
    'billing-address': payload['billing-address'],
    'billing-city': payload['billing-city'],
    'billing-state': payload['billing-state'],
    'billing-zip': payload['billing-zip'],
    'billing-country': payload['billing-country']
  }
  const regId = payload.regId
  try {
    const response = await (axios.post(BASE_URL + '/rpc/postSingleRegistration/'+regId, charge))
    return response.data
  } catch(err) {
    return {error: true, err: err, error_detail: 'There was an error on our server. Please contact support for help.'}
  }
}